import PropTypes from 'prop-types';
import React from 'react';

import cls from 'classnames/bind';

import isEqual from 'lodash/isEqual';
import noop from 'lodash/noop';

import { ANIMATION_TIME, MONTH_HEIGHT, WEEKDAYS_HEIGHT } from '../../calendarConstants';

import scrollIntoView from 'scroll-into-view';
import shallowCompare from 'shallow-compare';

import s from './MonthsNavigation.scss';

const cx = cls.bind(s);
class MonthsNavigation extends React.Component {
  static propTypes = {
    months: PropTypes.arrayOf(PropTypes.object),
    monthsWithDays: PropTypes.arrayOf(PropTypes.array),
    navigationHeight: PropTypes.number,
    datesScrollTop: PropTypes.number,
    onMonthClick: PropTypes.func,
  };

  static defaultProps = {
    onMonthClick: noop,
  };

  constructor(props, ctx) {
    super(props, ctx);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (isEqual(this.getBoxMetrics(nextProps), this.getBoxMetrics(this.props))) {
      return false;
    }

    return shallowCompare(this, nextProps, nextState);
  }

  isOverlap(start1, end1, start2, end2) {
    return end1 >= start2 && end2 >= start1;
  }

  getBoxMetrics(props) {
    const { datesScrollTop, months } = props;

    if (!this.monthsContainerRef) {
      return { top: 0, height: MONTH_HEIGHT };
    }

    const datesHeight = this.monthsContainerRef.getBoundingClientRect().height;

    const viewTop = datesScrollTop;
    const viewBottom = datesScrollTop + datesHeight - WEEKDAYS_HEIGHT;

    let offset = 0;
    let activeMonth = null;
    const topMargin = 10;
    const titleHeight = 21;
    const extraOffset = -WEEKDAYS_HEIGHT - titleHeight; // переходим на следующий месяц за неделю и titleHeight

    // пробегаемся по месяцам пока не найдем первый видимый
    // смотря на позицию скрола и расчитывая позицию каждого месяца offset += height
    // высота месяца это высота недель + title + margin

    for (let i = 0; i < months.length; i++) {
      const month = months[i];

      const weeksHeight = month.weeks.length * WEEKDAYS_HEIGHT;
      const height = titleHeight + weeksHeight;

      offset += topMargin;

      const isVisible = this.isOverlap(
        offset + extraOffset,
        offset + height + extraOffset,
        viewTop,
        viewBottom
      );

      if (isVisible) {
        activeMonth = i;
        break;
      }

      offset += height;
    }

    return {
      top: activeMonth * MONTH_HEIGHT,
      height: MONTH_HEIGHT,
    };
  }

  componentDidUpdate() {
    // todo check it
    const { monthsContainerRef, activeMonthBoxRef } = this;

    if (!monthsContainerRef || !activeMonthBoxRef || this._isNotScrollingMonthList) {
      return;
    }

    // алгоритм значительно упрощен, чтоб поддерживать длинные списки с несколькими годами
    scrollIntoView(activeMonthBoxRef, {
      time: ANIMATION_TIME,
      validTarget: (target) => target === monthsContainerRef,
    });
  }

  handleClick = (monthData, e) => {
    this._isNotScrollingMonthList = true;
    this.props.onMonthClick(
      monthData,
      () => {
        this._isNotScrollingMonthList = false;
      },
      e
    );
  };

  renderMonths() {
    const { months } = this.props;

    const currentYear = new Date().getFullYear();

    return (
      <div className={cx('months')}>
        {months.map(({ title, idx, year }, key) => {
          return (
            <div
              key={key}
              className={cx('month')}
              data-locator={`month-${idx + 1}`}
              onClick={this.handleClick.bind(this, { idx, year })}
            >
              {title}

              {currentYear !== year && <span className={cx('year')}> {year}</span>}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const activeBoxStyle = this.getBoxMetrics(this.props);

    return (
      <div
        className={cx('MonthsNavigation')}
        ref={(ref) => (this.monthsContainerRef = ref)}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className={cx('wrap')}>
          <div
            className={cx('activeMonthBox')}
            ref={(ref) => (this.activeMonthBoxRef = ref)}
            style={activeBoxStyle}
          />

          {this.renderMonths()}
        </div>
      </div>
    );
  }
}

export default MonthsNavigation;
